import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    container: {
      paddingTop: theme.spacing(4),
    },

    errorAlert: {
      marginBottom: theme.spacing(3),
    },

    productTitle: {
      margin: 0,
    },

    brandHeader: {
      marginBottom: theme.spacing(1),
    },

    brandHeaderLink: {
      alignItems: 'center',
      color: theme.palette.text.secondary,
      display: 'inline-flex',
      gap: theme.spacing(1.25),
      minWidth: 0,
      textDecoration: 'none',
      '&:hover': {
        color: theme.palette.text.primary,
        textDecoration: 'underline',
      },
    },

    brandHeaderLogo: {
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 4,
      display: 'inline-flex',
      height: 34,
      justifyContent: 'center',
      padding: theme.spacing(.45, .7),
      width: 86,
      '& picture': {
        display: 'flex',
        height: '100%',
        width: '100%',
      },
      '& img': {
        display: 'block',
        height: '100%',
        width: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: 'contain',
      },
    },

    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gap: theme.spacing(4),
    },

    imagesCarousel: {
      gridColumn: 'span 12',
      position: 'relative',
      overflow: 'hidden',
      [theme.breakpoints.up('sm')]: { gridColumn: 'span 7' },
    },

    addToCart: {
      gridColumn: 'span 12',
      [theme.breakpoints.up('sm')]: { gridColumn: 'span 5' },
    },

    magazineReturnButton: {
      background: 'linear-gradient(135deg, #29231d 0%, #6f5941 100%) !important',
      border: '1px solid rgba(255, 255, 255, .28)',
      borderRadius: 999,
      bottom: `calc(var(--product-purchase-bar-height, 0px) + ${theme.spacing(2.5)})`,
      boxShadow: '0 18px 46px rgba(49, 39, 28, .28)',
      color: '#fff !important',
      fontWeight: 800,
      letterSpacing: '.01em',
      overflow: 'hidden',
      padding: theme.spacing(1.15, 2.1),
      position: 'fixed',
      right: theme.spacing(2.5),
      textTransform: 'none',
      zIndex: 1300,
      '&:hover': {
        background: 'linear-gradient(135deg, #17130f 0%, #80674c 100%) !important',
        boxShadow: '0 22px 56px rgba(49, 39, 28, .34)',
      },
      '&::after': {
        background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, .28), transparent)',
        content: '""',
        inset: 0,
        opacity: .55,
        position: 'absolute',
        transform: 'translateX(-70%)',
        transition: 'transform .35s ease',
      },
      '&:hover::after': {
        transform: 'translateX(70%)',
      },
      '& .MuiButton-startIcon, & .MuiButton-label': {
        position: 'relative',
        zIndex: 1,
      },
      [theme.breakpoints.down('sm')]: {
        bottom: `calc(var(--product-purchase-bar-height, 0px) + ${theme.spacing(1.5)})`,
        left: theme.spacing(1.5),
        right: theme.spacing(1.5),
        justifyContent: 'center',
      },
    },

  })
)

export default useStyles
